import instance from "@/utils/require.js"

// 系统日志--登录日志
export function apiLoginLogSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/login_log/search",
		method: "post",
		data
	})
}

// 系统日志--操作日志
export function apiOperateLogSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/system_log/search",
		method: "post",
		data
	})
}

// 系统日志--生产日志
export function apiProcessLogSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_log/search",
		method: "post",
		data
	})
}

// 系统日志--错误日志
export function apiErrorLogSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/error_log/search",
		method: "post",
		data
	})
}

// 系统日志--日志详情
export function apiSystemLogDetail(data = {}) {
	return instance({
		url: "/aim/api/v3/system_log/detail",
		method: "post",
		data
	})
}

// 系统日志--生产日志详情
export function apProcessLogDetail(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_log/detail",
		method: "post",
		data
	})
}

// 系统日志--工序列表
export function apiWorkStationList(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/work_station/all",
		method: "post",
		data
	})
}